import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=8734%3A20611
 *
 * @param {SvgIconProps} props - svg props
 */
export const UmbrellaIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path fillRule='evenodd' clipRule='evenodd' d='M19.381 10.0651C16.3083 10.0195 15.6667 12.3931 15.6667 12.3931C15.6667 12.3931 15.0653 10.0955 11.9927 10.0955C11.9927 10.0955 9.08867 9.85243 8.28933 12.3437C8.28933 12.3437 7.93733 10.0803 4.63733 10.0803C4.63733 10.0803 2.00833 9.89041 1 12.4083C1 12.4083 2.54733 2.39755 11.2997 2.51908V1.75954C11.2997 1.75954 11.2667 1 12.022 1C12.825 1 12.7407 1.73296 12.7407 1.73296V2.51908C12.7407 2.51908 23 2.75454 23 12.294V12.3437C23 12.3437 22.0393 10.0651 19.381 10.0651ZM7.66967 19.2287C8.40301 19.2287 8.38101 20.0111 8.38101 20.0111C8.38101 20.0111 8.31134 21.5301 9.84767 21.5301C9.84767 21.5301 11.3143 21.4808 11.3143 20.0111V10.8738H12.7333V20.0111C12.7333 20.0111 12.7553 22.9999 9.82201 22.9999C9.82201 22.9999 6.88867 23.0492 6.88867 19.9883C6.88867 19.9883 6.93634 19.2287 7.66967 19.2287Z' fill={color}/>
        </SvgIcon>
    )
}

export default UmbrellaIcon
